import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Promo } from 'src/app/models/promo.model';
import { PromosService } from 'src/app/services/promos.service';
import { Router, ActivatedRoute } from '@angular/router';
import { PromoResult } from 'src/app/models/promoresult.model';
import { Page } from 'src/app/models/page.model';
import { ConfigKeys } from 'src/app/config/config.keys';
import { NgxSpinnerService } from 'ngx-spinner';
import { DomSanitizer } from '@angular/platform-browser';
import { BannersService } from 'src/app/services/banners.service';
import { Banner } from 'src/app/models/banner.model';
import { GoogleAnalyticsService } from 'mugan86-ng-google-analytics';
import { AppParam } from 'src/app/models/appparam.model';
import { ParamsService } from 'src/app/services/params.service';
import { ShowCardService } from 'src/app/services/ShowCard.service';


@Component({
  selector: 'app-promos',
  templateUrl: './promos.component.html',
  styleUrls: ['./promos.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class PromosComponent implements OnInit {

  banners: Banner[] = [];

  promos: Promo[] = [];
  promosMobile: Promo[] = [];
  currentPage: number = 0;
  disabledOnPrevButton = true;
  disabledOnNextButton = false;
  pages: Page[] = [];
  selectedIdCard: number = 1;


  //------VARS FOR HEADER--------
  appParams: AppParam[] = [];

  paramBCWebSiteURL: string = "";
  paramBCWebSiteURLTarget: number = 2;

  paramReqCardURL: string[] = [];
  paramReqCardURLTarget: number[] = [];




  configKeys: ConfigKeys = new ConfigKeys();

  constructor(
    private bannersService: BannersService,
    private sanitizer: DomSanitizer,
    private promosService: PromosService,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    public googleAnalyticsService: GoogleAnalyticsService,
    private paramsService: ParamsService,
    private showCardService: ShowCardService
  ) { }


  ngOnInit() {


    //--------FOR HEADER---------------
    this.paramsService.getAppParams().subscribe(
      (appParams: AppParam[]) => {
        this.appParams = appParams;
        this.paramsService.setAppParams(appParams);


        //-----------Set Parameter Values--------
        appParams.forEach(appParam => {

          if (appParam.cveParametro === this.configKeys.PARAM_BCOPPEL_URL) {
            this.paramBCWebSiteURL = appParam.valor;
            this.paramBCWebSiteURLTarget = appParam.target;
          }
          if (appParam.cveParametro === this.configKeys.PARAM_REQ_CARD_URL1) {
            this.paramReqCardURL[0] = appParam.valor;
            this.paramReqCardURLTarget[0] = appParam.target;
          }
          if (appParam.cveParametro === this.configKeys.PARAM_REQ_CARD_URL2) {
            this.paramReqCardURL[1] = appParam.valor;
            this.paramReqCardURLTarget[1] = appParam.target;
          }
          if (appParam.cveParametro === this.configKeys.PARAM_REQ_CARD_URL3) {
            this.paramReqCardURL[2] = appParam.valor;
            this.paramReqCardURLTarget[2] = appParam.target;
          }
          if (appParam.cveParametro === this.configKeys.PARAM_REQ_CARD_URL4) {
            this.paramReqCardURL[3] = appParam.valor;
            this.paramReqCardURLTarget[3] = appParam.target;
          }

        });


      }
    );


    var lastIdCard = this.route.snapshot.params['idCard'];
    var lastPage = this.route.snapshot.params['page'];

    if(!(lastIdCard===undefined && lastPage===undefined)){
           this.selectedIdCard=Number(lastIdCard);
           this.currentPage=Number(lastPage);
    }

   //----------FOR BANNERS
    this.bannersService.getBanners(this.selectedIdCard)
    .subscribe(
      (banners: Banner[]) => {
         this.banners = banners;
         this.bannersService.setBanners(banners);
      }
    );


     /* setTimeout(() => {
       this.spinner.hide();
     }, 5000); */

     if(this.currentPage===0)
       this.currentPage=1;

        /** spinner starts on init */
       this.spinner.show();
     this.promosService.getPromosByCardPage(this.selectedIdCard, this.currentPage)
     .subscribe(
       (promoResult: PromoResult) => {

        //  console.log('promoResult -> records: ' + promoResult.records);
        //  console.log('promoResult -> pages: ' + promoResult.pages);
        //  console.log('promoResult -> COUNT: ' + promoResult.count);
        //  console.log('promoResult -> hasPrev: ' + promoResult.hasPrevPage);
        //  console.log('promoResult -> hasNext: ' + promoResult.hasNextPage);

          this.promos = promoResult.promotions;
          this.promosService.setPromos(promoResult.promotions);

          this.setPagination(this.currentPage, promoResult.pages);
          this.spinner.hide();
       }
     );

     this.promosService.getPromosByCard(this.selectedIdCard)
     .subscribe(
       (promoResult: PromoResult) => {

          //console.log('promoResult -> records: ' + promoResult.records);
          //console.log('promoResult -> pages: ' + promoResult.pages);
          //console.log('promoResult -> COUNT: ' + promoResult.count);
          //console.log('promoResult -> hasPrev: ' + promoResult.hasPrevPage);
          //console.log('promoResult -> hasNext: ' + promoResult.hasNextPage);

          this.promosMobile = promoResult.promotions;
          this.promosService.setPromosMobile(promoResult.promotions);

       }
     );


  }

  getMobileFormat(bannerName : string){

    return bannerName.replace('promo-name', 'promo-name-mobile');

   }


   getXSMobileFormat(bannerName : string){

    return bannerName.replace('promo-name', 'promo-name-xsmobile');

   }

  setPagination(pageNumber:  number, totalPages: number){

         this.pages.splice(0, this.pages.length);

         for(var i=1; i<=totalPages; i++){

          let page = new Page(i, this.configKeys.ICON_INACTIVE_PAGE);

          if(i===pageNumber){
            page = new Page(i, this.configKeys.ICON_ACTIVE_PAGE);
          }

          this.pages.push(page);

         }

  }

  onPrevPage(){

    if(this.currentPage===1)
      return;

    this.currentPage =  this.currentPage - 1;
    var pageNumber = this.currentPage;

    //console.log('Displaying page: ' + pageNumber);

    this.spinner.show();
    this.promosService.getPromosByCardPage(this.selectedIdCard, pageNumber)
    .subscribe(
      (promoResult: PromoResult) => {
         //console.log('promoResult -> COUNT: ' + promoResult.count);
         //console.log('promoResult -> hasPrev: ' + promoResult.hasPrevPage);
         //console.log('promoResult -> hasNext: ' + promoResult.hasNextPage);
         this.promos = promoResult.promotions;
         this.promosService.setPromos(promoResult.promotions);

           if(promoResult.hasPrevPage)
           {
             this.disabledOnPrevButton=false;
           }
           else{
            this.disabledOnPrevButton=true;
           }

           this.disabledOnNextButton = !promoResult.hasNextPage;

           this.setPagination(pageNumber, promoResult.pages);
           this.spinner.hide();
      }
    );

  }

  onNextPage(){

    if(this.currentPage===this.pages.length)
     return;

    this.currentPage =  this.currentPage + 1;
    var pageNumber = this.currentPage;

    //console.log('Displaying page: ' + pageNumber);

    this.spinner.show();
    this.promosService.getPromosByCardPage(this.selectedIdCard, pageNumber)
    .subscribe(
      (promoResult: PromoResult) => {
         //console.log('promoResult -> COUNT: ' + promoResult.count);
         //console.log('promoResult -> hasPrev: ' + promoResult.hasPrevPage);
         //console.log('promoResult -> hasNext: ' + promoResult.hasNextPage);
         this.promos = promoResult.promotions;
         this.promosService.setPromos(promoResult.promotions);

           if(promoResult.hasNextPage)
           {
             this.disabledOnNextButton=false;
           }
           else{
            this.disabledOnNextButton=true;
           }

           this.disabledOnPrevButton =  !promoResult.hasPrevPage;

           this.setPagination(pageNumber, promoResult.pages);
           this.spinner.hide();
      }
    );

  }


  showPage(event: Event) {

    let pageNumber = (Number)((<HTMLImageElement>event.target).id);

    this.currentPage=pageNumber;

   // console.log('Displaying page: ' + pageNumber);

    this.spinner.show();
    this.promosService.getPromosByCardPage(this.selectedIdCard, pageNumber)
    .subscribe(
      (promoResult: PromoResult) => {
       //  console.log('promoResult -> COUNT: ' + promoResult.count);
       //  console.log('promoResult -> hasPrev: ' + promoResult.hasPrevPage);
       //  console.log('promoResult -> hasNext: ' + promoResult.hasNextPage);
         this.promos = promoResult.promotions;
         this.promosService.setPromos(promoResult.promotions);

           this.disabledOnPrevButton =  !promoResult.hasPrevPage;
           this.disabledOnNextButton =  !promoResult.hasNextPage;

           this.setPagination(pageNumber, promoResult.pages);
           this.spinner.hide();
      }
    );

  }

  onCardSelected(idCard: number){

    this.showCardService.setSelectedCard('' + (idCard-1));

    this.bannersService.getBanners(idCard)
    .subscribe(
      (banners: Banner[]) => {
         this.banners = banners;
         this.bannersService.setBanners(banners);
      }
    );

    this.selectedIdCard=idCard;
    let pageNumber = 1;

     this.currentPage = 1;

   // console.log('Displaying page by card: ');

    this.spinner.show();
    this.promosService.getPromosByCardPage(idCard,pageNumber)
    .subscribe(
      (promoResult: PromoResult) => {
       //  console.log('promoResult -> COUNT: ' + promoResult.count);
       //  console.log('promoResult -> hasPrev: ' + promoResult.hasPrevPage);
       //  console.log('promoResult -> hasNext: ' + promoResult.hasNextPage);
         this.promos = promoResult.promotions;
         this.promosService.setPromos(promoResult.promotions);

           this.disabledOnPrevButton =  !promoResult.hasPrevPage;
           this.disabledOnNextButton =  !promoResult.hasNextPage;

           this.setPagination(pageNumber, promoResult.pages);
           this.spinner.hide();
      }
    );

    this.promosService.getPromosByCard(idCard)
     .subscribe(
       (promoResult: PromoResult) => {

        //  console.log('promoResult -> records: ' + promoResult.records);
        //  console.log('promoResult -> pages: ' + promoResult.pages);
        //  console.log('promoResult -> COUNT: ' + promoResult.count);
        //  console.log('promoResult -> hasPrev: ' + promoResult.hasPrevPage);
        //  console.log('promoResult -> hasNext: ' + promoResult.hasNextPage);

          this.promosMobile = promoResult.promotions;
          this.promosService.setPromosMobile(promoResult.promotions);

       }
     );

  }

  showPromo(event: Event) {

    let idPromocion = (Number)((<HTMLButtonElement>event.target).id);

     //console.log('PROMO SELECCIONADA: ' + idPromocion);

     this.router.navigate(['showPromo']);
  }


  goToLink(url: string, target: number, promoName: string){


    //--------------Call Google Analytics Event
    // this.googleAnalyticsService.eventEmitter('Promociones', 'Visitas Informativas',  'Informativa: Bancoppel - ' + promoName, 1);
    enum BCards {
      Debito = 1,
      Clasica,
      Oro,
      Platinum,
      Clic,
    };
    this.googleAnalyticsService.eventEmitter('Promociones', BCards[this.selectedIdCard],  'Informativa (' + BCards[this.selectedIdCard] + '): Bancoppel - ' + promoName, 1);
    //--------------Call Google Analytics 4 Event
    this.eventGA4PushInteractions('bancoppel_promociones', BCards[this.selectedIdCard],  'Informativa (' + BCards[this.selectedIdCard] + '): Bancoppel - ' + promoName);

    if(target===2)
      window.open(url, "_blank");
    else
      window.location.href=  url;
  }



  //------ FOR HEADERS---------

  goToWebSite() {

    var url = this.paramBCWebSiteURL;

    if (2 === this.paramBCWebSiteURLTarget)
      window.open(url, "_blank");
    else
      window.location.href = url;

  }


  goToReqCard() {

    var url = this.paramReqCardURL[this.selectedIdCard-1];

    var wtarget =  this.paramReqCardURLTarget[this.selectedIdCard-1];

    if (2 === wtarget)
      window.open(url, "_blank");
    else
      window.location.href = url;

  }

  eventGA4PushInteractions(event: string, card_campaign_sendingmean: string, labelValue: string) {

    // console.log('Registering event in GA4: ' + event);

    if (event === 'bancoppel_promociones') {
      (<any>window).dataLayer.push({
        event: event,
        card_campaign: card_campaign_sendingmean,
        promo_name: labelValue
      });
    } else if (event === 'bancoppel_banners') {
      (<any>window).dataLayer.push({
        event: event,
        card_campaign_banners: card_campaign_sendingmean,
        banner_name: labelValue
      });
    } else if (event === 'social_share') {
      (<any>window).dataLayer.push({
        event: event,
        sending_mean: card_campaign_sendingmean,
        promo_name_ss: labelValue
      });
    }
  }


}
